import { Alert } from "react-bootstrap";

const Error = () => (
  <Alert variant="danger">
    <p style={{ textAlign: "center" }}>
      An error occurred😑<br></br> Sorry.<br></br> Please try again a little
      later.
    </p>
  </Alert>
);

export default Error;
